import { categories } from '@/mocks/manga';

export default function Categories() {
  return (
    <section id="categories" className="scroll-mt-20 bg-background-100 py-12 md:py-16">
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-6">
        <div className="text-center">
          <p className="inline-flex items-center gap-1 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-800">
            <i className="ri-grid-fill text-accent-600"></i>
            全题材覆盖
          </p>
          <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-3xl">按题材挑选你爱的连载</h2>
          <p className="mx-auto mt-2 max-w-xl text-sm text-foreground-600">
            热血、奇幻、悬疑、恋爱、搞笑……总有一部汉化连载适合此刻的你。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-2 gap-4 md:grid-cols-4">
          {categories.map((c) => (
            <a
              key={c.name}
              href="#featured"
              className="group flex flex-col items-center gap-3 rounded-2xl border border-background-200 bg-background-50 p-5 text-center transition-all hover:-translate-y-1 hover:border-accent-300 hover:bg-accent-50"
            >
              <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-primary-100 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50 md:h-16 md:w-16">
                <i className={`${c.icon} text-2xl`}></i>
              </span>
              <div>
                <h3 className="text-sm font-bold text-foreground-950 md:text-base">{c.name}</h3>
                <p className="mt-0.5 text-xs text-foreground-600">{c.desc}</p>
              </div>
              <span className="rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold text-secondary-900">
                {c.count} 部连载
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}